module.exports = __webpack_public_path__ + "static/img/list-picoNesalMask.49a2ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-picoNesalMask.png
// module id = 8ajN
// module chunks = 1